<template>
  <div id="app" style="height:100%">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
hr {
  border: 1px solid #eff2f6;
}
.mint-toast {
  z-index: 9999 !important;
}

.mint-toast.is-placemiddle {
  top: 40%;
}
/* html{filter: grayscale(100%);filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); -webkit-filter: grayscale(100%);-moz-filter: grayscale(100%);} */
</style>



// WEBPACK FOOTER //
// src/App.vue